export const REDUCER_NAME='logoslice';

export interface iLogoDTO {
    logoUrl?: string |File;
    altText?: string;
    width: number;
    height: number;
    appName?:string;
    copyRights?:string;
}

export interface iLogoResponse{
  currentTheme: any;
  activeRadiumThemeId?: string;
  tokenPaymentUrl?: string | null;
  tokenPaymentTitle?: string | null;
  tokenPaymentButton?: string | null;
  tokenPaymentNote?: string | null;
  vendorId?: string;
    id: string;
  appName: string;
  domain?: string;
  appType: "web" | "mobile" | "desktop";
  appColor?: string;
  logoUrl?: string;
  created_at: string;
  updated_at: string;
  email:string;
  mobile:string;
  address:string;
  copyRights?:string;
  minimumWalletAmountForWholesaler?:number;
  minimumWalletAmountForReseller?:number;
  currency?: string;
}

export interface iLogoState {
      logoList: iLogoResponse[] | null;
      isLoading: boolean;
      errorMessage: string | null;
  }
  
  export type UpdateThemePayload =
  | { currentTheme: string }
  | { currentMobileTheme: string };
